import { render, staticRenderFns } from "./OverDueEmiTable.vue?vue&type=template&id=481b77f8&scoped=true"
import script from "./OverDueEmiTable.vue?vue&type=script&lang=js"
export * from "./OverDueEmiTable.vue?vue&type=script&lang=js"
import style0 from "./OverDueEmiTable.vue?vue&type=style&index=0&id=481b77f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481b77f8",
  null
  
)

export default component.exports